import classNames from "classnames";
import Styles from "./JoinUs.module.scss";
import Navbar from "../../Component/Navbar/Navbar";
import Footer from "../../Component/Footer/Footer";
import Jumbotron from "../../Component/Jumbotron/Jumbotron";
import volunteer from "../../assets/images/index/加入我們_2.jpg";
import Title from "../../Component/Text/Title";
import {
  faHandHoldingHeart,
  faHandshakeAngle,
} from "@fortawesome/free-solid-svg-icons";
import Card1 from "../../Component/Card/Card1";
import img1 from "../../assets/images/index/長照諮詢.jpg";
import img2 from "../../assets/images/index/九九重陽.jpg";
import img3 from "../../assets/images/index/認養部分負擔.jpg";
import img4 from "../../assets/images/index/幸福2-1.jpg";

const JoinUs = () => {
  return (
    <div>
      <Navbar />
      <div style={{ paddingTop: "8vh" }}>
        <Jumbotron
          img={volunteer}
          text={`加入我們 
          `}
        />
      </div>
      {/* 我要捐款 */}
      <div style={{ display: "none" }}>
        <Title iconName={faHandHoldingHeart} text={`我要捐款`} />
        <div className={classNames("container", Styles.joinus)}>
          <div className={classNames("col-8", Styles.joinus__description)}>
            <p>
              戶名：社團法人中華廣博長照發展協會
              <br />
              銀行匯款：(004) 257001012768
            </p>
          </div>
          <div className={classNames("col-4")}>
            <div className={classNames(Styles.joinus__wrapper)}>
              <img src="https://kuang-bo.s3.ap-southeast-1.amazonaws.com/static/media/LOGO.c0c5a38102d94b82e6fc.png" />
            </div>
          </div>
        </div>
      </div>

      {/* 企業合作 */}
      <div className={classNames("container")}>
        <Title iconName={faHandshakeAngle} text={`企業合作`} />
        <div className={classNames(Styles.joinus__cooperate)}>
          <p className={classNames(Styles.joinus__cooperate__description)}>
            可於本會於花蓮縣行駛的長照巴士聯名廣告。
            <br />
            讓長照巴士與企業廣告行走於花蓮各鄉鎮，讓企業優良形象深植於花蓮縣市的鄉鎮，
            <br />
            有利於企業的慈善服務形象，也有利於協會本身，
            特別是針對老人、身心障礙者的族群。
            <br />
            讓關心弱勢族群的一般民眾，對企業產生共鳴。
          </p>
        </div>
        <div>
          <div className={classNames(Styles.joinus)}>
            <div className={classNames("col-lg-4", "col-md-12", "col-sm-12")} >
              <div className={classNames(Styles.joinus__cooperate__card)}>
                <Card1 img={img1} text={`居家老人\n溫馨過好年`} />
              </div>
            </div>
            <div className={classNames("col-lg-4", "col-md-12", "col-sm-12")} >
              <div className={classNames(Styles.joinus__cooperate__card)}>

                <Card1 img={img2} text={`重陽九九祝康壽`} />
              </div>
            </div>
            <div className={classNames("col-lg-4", "col-md-12", "col-sm-12")} >
              <div className={classNames(Styles.joinus__cooperate__card)}>
                <Card1
                  img={img3}
                  text={`認養花蓮鄉鎮清寒老人的居家服務部分負擔`}
                />
              </div>
            </div>

          </div>
          <div className={classNames(Styles.joinus)}>
            <div className={classNames("col-lg-4", "col-md-12", "col-sm-12")} >
              <div className={classNames(Styles.joinus__cooperate__card)}>
                <Card1 img={volunteer} text={`成為志工`} />
              </div>
            </div>
            <div className={classNames("col-lg-4", "col-md-12", "col-sm-12")} >
              <div className={classNames(Styles.joinus__cooperate__card)}>

                <Card1 img={img4} text={`支持協會舉辦的\n服務體驗活動`} />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div>
        <Footer />
      </div>
    </div>
  );
};

export default JoinUs;
